import React, { useState } from 'react';
import useEditorStore from '../../stores/useEditorStore';
import { useToolManager } from '../../hooks/useToolManager';

const ScissorsToolCard = () => {
  const [hovered, setHovered] = useState(null);
  const setActiveTool = useEditorStore((state) => state.setActiveTool);
  const { run } = useToolManager();

  const modes = [
    { id: 'trim', label: 'Trim', icon: '/tool_icons/scan_preparing_scissors_trim.png' },
    { id: 'invert', label: 'Invert', icon: '/tool_icons/scan_preparing_scissors_invert.png' },
    { id: 'unselect', label: 'Unselect', icon: '/tool_icons/scan_preparing_scissors_unselect.png' }
  ];

  const onToolClick = (mode) => {
    run({tool: 'scan_preparing_scissors', mode: mode.id})
  };

  return (
    <div className="absolute top-2 left-2 bg-white/60 rounded-lg p-4 shadow z-50 min-w-[200px]">
      {/* Mode Buttons (simple, not selectable) */}
      <div className="flex flex-col gap-2">
        {modes.map((mode) => (
          <button
            key={mode.id}
            onMouseEnter={() => setHovered(mode.id)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => onToolClick(mode)}
            className={`flex items-center bg-white w-full p-3 font-normal text-left text-[var(--odp-purple-dark)] border border-[var(--odp-purple-dark)] rounded-md cursor-pointer transition 
              hover:bg-violet-400 hover:text-white hover:border-[var(--odp-purple-light)] active:scale-95`}
          >
            <img 
              src={mode.icon} 
              alt={mode.label}
              className='w-5 h-5 mr-3'
            />
            {mode.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScissorsToolCard; 